import { render, staticRenderFns } from "./MainCarouselItem.vue?vue&type=template&id=6cb2df1c&"
import script from "./MainCarouselItem.vue?vue&type=script&lang=js&"
export * from "./MainCarouselItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cb2df1c')) {
      api.createRecord('6cb2df1c', component.options)
    } else {
      api.reload('6cb2df1c', component.options)
    }
    module.hot.accept("./MainCarouselItem.vue?vue&type=template&id=6cb2df1c&", function () {
      api.rerender('6cb2df1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainCarouselItem.vue"
export default component.exports